import CustomOptionSelector from './cellRenderers/customOptionSelector.component';

export const defaultDateCellEditor = {
  component: 'DateCellEditor',
  popup: true,
};

export const defaultAgRichSelectCellEditorSelector = {
  component: 'agRichSelectCellEditor',
  popup: true,
};

export const defaultAgRichSelectCellEditor = {
  cellEditor: 'agRichSelectCellEditor',
  cellEditorPopup: true,
};

/** In-cell native select; avoids agRichSelect popup width/focus issues after AG Grid v32. */
export const defaultNativeSelectCellEditor = {
  cellEditor: 'CheckboxGroupNativeSelectCellEditor',
};

export const defaultNativeSelectCellEditorSelector = {
  component: 'CheckboxGroupNativeSelectCellEditor',
  popup: false,
};

export const defaultCustomOptionCellSelector = {
  component: CustomOptionSelector,
  popup: true,
};
